import script from "./PreviewHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewHome.vue?vue&type=script&setup=true&lang=js"

import "./PreviewHome.vue?vue&type=style&index=0&id=5a804986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a804986"]])

export default __exports__